import React, {useState} from 'react';
import './AccountLimitReached.css';

const AccountLimitReached = props => {
    const {closeModal, numberOfUserToTarget, maximumNumberOfMessagesCompanyCanSend} = props;
    const siteUrl = "https://digitalnakarticapro.com/";
    const [checkedIncreaseAccountBalance, setCheckedIncreaseAccountBalance] = useState(false);
    const [checkedChangeCriteria, setCheckedChangeCriteria] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (checkedIncreaseAccountBalance) {
            window.open(siteUrl, "_blank");
            closeModal()
        } else {
            closeModal()
        }
    };

    const handleChange = (event) => {
        if (event.target.name === 'increaseAccountBalance') {
            setCheckedIncreaseAccountBalance(true);
            setCheckedChangeCriteria(false);
        } else if (event.target.name === 'changeCriteria') {
            setCheckedChangeCriteria(true);
            setCheckedIncreaseAccountBalance(false);
        }
    };

    return (
        <div className='account-limit-reached-wrapper'>
            <h2 className='account-limit-reached-header'>Prekoračen Limit Računa</h2>
            <p className='account-limit-reached-message'>Broj poruka koje želite da pošaljete je veći od stanja na vašem
                računu.</p>
            <div className='account-limit-reached-number-wrapper' >
                <p className='account-limit-reached-number-of-message'>Trenutno poruka na računu : {numberOfUserToTarget}</p>
                <p className='account-limit-reached-number-of-target'>Pokušavate da pošaljete : {maximumNumberOfMessagesCompanyCanSend}</p>
            </div>
            <h4 className='account-limit-reached-continue-message'>Izaberte opciju i kliknite NASTAVI</h4>
            <form onSubmit={handleSubmit}>
                <div className='account-limit-reached-bottom-wrapper'>
                    <div className='account-limit-reached-checkbox-wrapper'>
                        <label className='account-limit-reached-form-label'
                               htmlFor="increaseAccountBalance">
                            Dodajte kredit na račun
                        </label>
                        <input type="checkbox"
                               name='increaseAccountBalance'
                               id='increaseAccountBalance'
                               checked={checkedIncreaseAccountBalance}
                               onChange={handleChange}/>
                    </div>
                    <div className='account-limit-reached-checkbox-wrapper'>
                        <label className='account-limit-reached-form-label'
                               htmlFor="changeCriteria">
                            Promenite kriterijume
                        </label>
                        <input type="checkbox"
                               name='changeCriteria'
                               id='changeCriteria'
                               checked={checkedChangeCriteria}
                               onChange={handleChange}/>
                    </div>
                    <div className='account-limit-reached-button-wrapper'>
                        <input className='account-limit-reached-button'
                               type="submit"
                               value="NASTAVI"/>
                    </div>
                </div>

            </form>
        </div>
    )
};

export default AccountLimitReached;
